<template>
  <WhiteTooltipMenu
    :title="$t('pos_sync_tooltip.title')"
    @close="$emit('close')"
  >
    <div class="pos-sync-block">
      <div class="gap-row-2xs">
        <div class="qrw-label-lg bold v1-grey-10-color">
          {{ $t("pos_sync_tooltip.manual_sync") }}
        </div>
        <div class="qrw-paragraph-md-sm v1-grey-7-color">
          {{ $t("pos_sync_tooltip.manual_sync_desc") }}
        </div>
      </div>

      <div class="sync-button-block">
        <BaseButton
          variant="primary"
          icon="refresh-ccw-bold"
          class="w-100"
          color="green-5"
          size="md"
          @click="startManualSync"
          v-if="sync_menu_state == 'idle'"
        >
          {{ $t("pos_sync_tooltip.btn_sync") }}
        </BaseButton>
        <div class="gap-row-2xs" v-else>
          <div class="qrw-container-title-bold v1-grey-10-color bold">
            {{
              sync_menu_state == "in_progress" ? `${sync_progress}%` : $t('pos_sync_tooltip.manual_done')
            }}
          </div>
          <div class="gap-column-zero">
            <div
              class="sync-progress-bar w-100"
              :class="{
                filled: sync_menu_state == 'done' || sync_progress == 50,
              }"
            ></div>

            <div
              class="sync-progress-bar w-100"
              v-if="sync_menu_state != 'done'"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <BaseDivider color="v1-grey-4" />
    <div class="pos-sync-block">
      <div class="gap-row-2xs">
        <div class="gap-column-1xs toggle-row">
          <div class="qrw-label-lg bold v1-grey-10-color w-100">
            {{ $t("pos_sync_tooltip.menu_sync") }}
          </div>

          <IQOSToggle
            :value="poster_sync_options.sync_menu"
            @input="(v) => changeSyncValue('sync_menu', v)"
          />
        </div>

        <div class="qrw-paragraph-md-sm v1-grey-7-color">
          {{ $t("pos_sync_tooltip.menu_sync_desc") }}
        </div>
      </div>
    </div>

    <BaseDivider color="v1-grey-4" />
    <div class="pos-sync-block">
      <div class="gap-row-2xs">
        <div class="gap-column-1xs toggle-row">
          <div class="qrw-label-lg bold v1-grey-10-color w-100">
            {{ $t("pos_sync_tooltip.storage_sync") }}
          </div>

          <IQOSToggle
            :value="poster_sync_options.sync_storage"
            @input="(v) => changeSyncValue('sync_storage', v)"
          />
        </div>

        <div class="qrw-paragraph-md-sm v1-grey-7-color">
          {{ $t("pos_sync_tooltip.storage_sync_desc") }}
        </div>
      </div>
    </div>
  </WhiteTooltipMenu>
</template>

<script>
import PosterAPI from "@/api/poster";

export default {
  data() {
    return {
      sync_menu_state: "idle",
      sync_progress: 0,
      poster_sync_options: {
        sync_menu: true,
        sync_waiters: true,
        sync_tables: true,
        sync_storage: false,
        sync_transactions: false,
      },
    };
  },
  methods: {
    startManualSync() {
      this.sync_progress = 0;
      this.sync_menu_state = "in_progress";

      const promise =
        this.currentPosSystem == "poster"
          ? PosterAPI.resyncAllPrices(this.cafe._id)
          : Promise.resolve();

      promise
        .then((data) => {
          this.sync_progress = 50;

          this.$store.dispatch("menu/fetchMenus").then(() => {
            this.sync_menu_state = "done";

            setTimeout(() => {
              this.sync_menu_state = "idle";
            }, 2000);
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "poster_error");
        });
    },
    reset() {
      this.poster_sync_options.sync_menu = this.cafe.poster.sync_menu;
      this.poster_sync_options.sync_waiters = this.cafe.poster.sync_waiters;
      this.poster_sync_options.sync_tables = this.cafe.poster.sync_tables;
      this.poster_sync_options.sync_storage = this.cafe.poster.sync_storage;
      this.poster_sync_options.sync_transactions =
        this.cafe.poster.sync_transactions;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    showEditUI() {
      this.editing = true;
    },
    onEditFinish() {
      this.$store.commit("setPosterSyncOptions", this.poster_sync_options);
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "change_poster_sync",
        payload: this.poster_sync_options,
      });

      this.editing = false;
    },
    changeSyncValue(key, value) {
      // if (!this.editing) return;

      this.poster_sync_options[key] = value;
      this.onEditFinish();

      if (key == 'sync_storage' && !value) {
        this.$emit('storageSyncDisabled');
      }
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    currentPosSystem() {
      return this.$store.getters.currentPosSystem;
    },
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style scoped>
.pos-sync-block {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  background: var(--v1-grey-1-color);
  padding: 16px;
  box-sizing: border-box;
}

.sync-button-block {
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
}

.toggle-row {
  align-items: center;
}

.sync-progress-bar {
  width: 100%;
  border-radius: 8px;
  height: 4px;
  max-height: 4px;
  background: var(--v1-grey-4-color);
}

.sync-progress-bar.filled {
  background: var(--green-5-color);
}
</style>